import React from "react";
import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getDefaultRoute } from "../data/menu";

const PublicRoute = ({ component }) => {
  const isAuth = window.localStorage.getItem("access_token");

  const getRedirectPath = () => {
    try {
      const roleStr = window.localStorage.getItem("role");
      if (roleStr && roleStr !== "undefined") {
        const role = JSON.parse(roleStr);
        return getDefaultRoute(role?.permissions);
      }
    } catch (e) {
      console.error(e);
    }
    return "/dashboard";
  };

  const navToLandingPage = () => {
    toast.warning("Already login");
    return <Navigate to={getRedirectPath()} />;
  };
  return isAuth ? navToLandingPage() : component;
};

export default PublicRoute;
